<template>
  <b-sidebar
    id="print-list-sidebar"
    :visible="isPrintListSidebarActive"
    :bg-variant="COLOR_VARIANTS.WHITE"
    shadow
    no-header
    right
    @change="val => $emit('update:is-print-list-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          <span v-if="list.length < 1">{{ $t('application.printListModal.title') }}</span>
          <span v-else>{{ $t('application.printListModal.titleWithCount')}} {{ list.length }}</span>
        </h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>
      <!-- export to csv-->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <b-button
          :disabled="list.length < 1"
          variant="outline-secondary"
          class="d-flex align-items-center"
          @click="exportToCsv"
        >
          <feather-icon icon="DownloadIcon" size="16" />
          <span class="ml-50">{{ $t('application.printListModal.exportToCsv') }}</span>
        </b-button>
      </div>
      <!-- Body -->
      <!-- In body display a table of all the items in print list, with action button to remove item from the list -->
      <div
        v-if="list.length < 1"
        style="padding: 10px;">
        Lisää listaan klikkaamalla työntekijän nimeä.</div>
      <b-table
        v-if="list.length > 0"
        responsive
        :fields="['fullName', 'actions']"
        :small= "true"
        :items="list"
        :striped="true"
        :bordered="true"
        :borderless="true"
        :head-variant="COLOR_VARIANTS.WHITE"
        :tbody-tr-class="() => 'cursor-pointer'"
        :tbody-tr-style="() => 'border-bottom: 1px solid #E5E5E5'"
        :tbody-td-class="() => 'align-middle'"
        :tbody-td-style="() => 'vertical-align: middle'"
        :tbody-td-attr="() => ({ 'data-label': $t('application.printListModal.table.name') })"
        :no-border-collapse="true"
      >
        <template #cell(fullName)="row">
          <div class="d-flex align-items-center">
            <div class="mr-1">
              <feather-icon icon="UserIcon" size="16" />
            </div>
            <div>
              {{ row.value }}
            </div>
          </div>
        </template>
        <template #cell(actions)="row">
          <div class="d-flex align-items-center">
            <div class="mr-1">
              <feather-icon icon="TrashIcon" size="16" @click="() => remove(row.item.id)" />
            </div>
            <div>
              {{ row.value }}
            </div>
          </div>
        </template>
      </b-table>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BTable,
  BButton,
} from 'bootstrap-vue'
import { COLOR_VARIANTS } from '@/shared/constants'
import { mapState } from 'vuex'

export default {
  name: 'PrintList',
  components: {
    BSidebar,
    BTable,
    BButton,
  },
  props: {
    isPrintListSidebarActive: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      COLOR_VARIANTS,
    }
  },
  computed: {
    ...mapState({
      applications: state => state.applications.applications,
    }),
  },
  methods: {
    remove(id) {
      this.$emit('remove', id)
    },
    exportToCsv() {
     this.$emit('exportToCsv')
    }
  },
}

</script>
        
